const messages = {
  title: "Home",
  welcomeMessage:
    'Welkom bij BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Home",
  search: "Zoeken",
  sortBy: "Sorteren op",
  seeMore: "Meer weergeven",
  bankstatement: {
    yourScore: "Uw huidige aantal marketingpunten:",
    lastUpdate: "Laatste update:",
    link: "Overzicht puntensaldo",
    kickbackLink: "Overzicht bonus",
    yourKickback: "Uw huidige bonus",
  },
  shop: {
    bestSold: "Meest verkocht",
    seasonal: "Seizoensgebonden",
    affordable: "Ontdek",
    forPoints: "{points} punten",
    reachedPoints: "Voldoende punten beschikbaar",
    cartRemainPoints: "Resterende punten",
    remainingPoints: "Nog {points} punten nodig",
    noProducts: "De zoekcriteria leverden geen treffers op",
    variant: "Varianten beschikbaar",
  },
  showAllProducts:
    "Naar de Bridgestone <span class='text-danger'>Plus</span> shop",
  shopCommingSoon:
    "Het waarderen van uw inzet, <div>dat is wat echt telt!</div><div class='font-25'>De cadeaucatalogus is binnenkort beschikbaar.</div><div class='font-25'>Kies een beloning die bij u past!</div>",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>is binnenkort weer beschikbaar.</div>",
  profile: {
    welcome: "Welkom",
    completeProfile: "Vul uw persoonlijke profiel in en verdien",
    completeProfileBold: "25 extra punten.",
    link: "Profiel tonen",
    fullCompleteProfile: "Je persoonlijke profiel is compleet! ",
  },
  pobox: {
    newMessages: "Nieuwe berichten in uw inbox",
    link: "inbox openen",
  },
};

export default {
  messages,
};
